import { combineReducers } from 'redux';
import _listingReducer from 'circe/listing/reducer';
import { REDUCER_NAME as CREDIT_TERMS_REDUCER_NAME } from './constants';
import { REDUCER_NAME as TRANSACTIONS_REDUCER_NAME } from './transactions/constants';
import transactionsReducer from './transactions/reducer';
import actionTypes from './actionTypes';

const listingReducer = _listingReducer(actionTypes);

const updateObjectInArray = (data, id, values) => data.map((item) => {
  if (item.creditTerms.id === id) {
    return {
      ...item,
      ...values,
    };
  }
  return item;
});

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.REVOKE:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, { isRevoking: true }),
      };

    case actionTypes.REVOKED:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, {
          isRevoking: false,
          ...action.payload.data,
        }),
      };

    case actionTypes.ACTIVATE:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, {
          isActivating: true,
        }),
      };

    case actionTypes.ACTIVATED:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, {
          ...action.payload.data,
          isActivating: false,
          active: true,
        }),
      };

    case actionTypes.REVOKE_FAILED:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, { isRevoking: false }),
      };

    case actionTypes.REPLENISH:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, { isReplenishing: true }),
        isReplenished: false,
      };

    case actionTypes.REPLENISHED:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, {
          isReplenishing: false,
          isReplenished: true,
          ...action.payload.data,
        }),
      };

    case actionTypes.REPLENISH_FAILED:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, { isReplenishing: false }),
      };

    case actionTypes.INVOICE_CREATE:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, { isInvoiceCreating: true }),
      };

    case actionTypes.INVOICE_CREATED:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, {
          isInvoiceCreating: false,
          ...action.payload.data,
        }),
      };

    case actionTypes.INVOICE_CREATE_FAILED:
      return {
        ...state,
        data: updateObjectInArray(state.data, action.payload.id, { isInvoiceCreating: false }),
      };

    case actionTypes.CREATE:
      return {
        ...state,
        isCreating: true,
      };

    case actionTypes.CREATED:
      return {
        ...state,
        isCreating: false,
        data: [action.payload.data, ...state.data],
      };

    default:
      return listingReducer(state, action);
  }
};

export default combineReducers({
  [CREDIT_TERMS_REDUCER_NAME]: reducer,
  [TRANSACTIONS_REDUCER_NAME]: transactionsReducer,
});
